import { useEffect, useState } from 'react';

import { PlusIcon } from 'lucide-react';
import { Button, DefaultTooltip } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import ToggleGroupRow from './ToggleGroupRow';

export default function TextAlignContainerProperty() {
  const { value: vertical } = useCraftProp('textAlignContainer.vertical')
  const [showVertical, setShowVertical] = useState()

  useEffect(() => {
    if (showVertical === undefined) {
      setShowVertical(!!vertical)
    }
  }, [showVertical, vertical])

  const horizontalGroup = {
    props: { type: 'single', name: 'textAlignContainer.horizontal', className: 'w-full' },
    options: [
      { value: 'left', icon: 'AlignLeftIcon', tooltip: 'Left', className: 'p-1' },
      { value: 'center', icon: 'AlignCenterIcon', tooltip: 'Center', className: 'p-1' },
      { value: 'right', icon: 'AlignRightIcon', tooltip: 'Right', className: 'p-1' },
      { value: 'justify', icon: 'AlignJustify', tooltip: 'Justify', className: 'p-1' },
    ],
  }

  const verticalGroup = {
    props: { type: 'single', name: 'textAlignContainer.vertical', className: 'w-full' },
    options: [
      { value: 'top', icon: 'ArrowUpToLine', tooltip: 'Top', className: 'p-1' },
      { value: 'middle', icon: 'FlipVertical2', tooltip: 'Middle', className: 'p-1' },
      { value: 'bottom', icon: 'ArrowDownToLine', tooltip: 'Bottom', className: 'p-1' },
    ],
  }

  const groups = showVertical ? [horizontalGroup, verticalGroup] : [horizontalGroup]

  return <>
    <ToggleGroupRow groups={groups}>
      {!showVertical && <>
        <DefaultTooltip content='Add Vertical Align' side='left'>
          <Button variant='light' onClick={() => setShowVertical(true)}>
            <PlusIcon size='14' />
          </Button>
        </DefaultTooltip>
      </>}
    </ToggleGroupRow>
  </>
}

